import React from "react";
import { MonitorIcon, PrinterIcon, SmartphoneIcon, TabletIcon } from "lucide-react";
const devices = [{
  label: "Computer",
  Icon: MonitorIcon
}, {
  label: "Tablet",
  Icon: TabletIcon
}, {
  label: "Smartphone",
  Icon: SmartphoneIcon
}];
export function DigitalAccess() {
  return <section className="bg-peach px-4 py-16" aria-label="Digital access" data-id="element-54" data-mp="1k0pqsaz2teqr">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-2" data-id="element-55" data-mp="1k2tx0zkg6pu7">
        <div data-id="element-56" data-mp="wbezdk3m8wpa">
          <h2 className="font-heading text-2xl font-bold uppercase" data-id="element-57" data-mp="wczjefsb0x8w">
            Instant <span className="text-brand" data-id="element-58" data-mp="rdd6k7ge1j0m">digital access</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink-muted" data-id="element-59" data-mp="15btmmp054lvf">Your woodworking plans are delivered digitally. That means you can use them on:</p>
          <ul className="mt-5 flex flex-wrap gap-3" data-id="element-60" data-mp="10eti4iixvr6f">
            {devices.map(({
            label,
            Icon
          }) => <li key={label} className="flex items-center gap-2 rounded-md bg-white px-4 py-2.5 text-sm font-medium" data-id="element-61" data-mp="2gsjppz99oxkt">
                <Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-62" data-mp="37ug6i5ge8hp7" />
                {label}
              </li>)}
          </ul>
          <p className="mt-5 text-sm leading-relaxed text-ink-muted" data-id="element-63" data-mp="3bu6u60amihpi">Or print the pages you want to keep beside you in the workshop.</p>
          <p className="mt-4 font-heading text-sm font-bold" data-id="element-64" data-mp="3gt1kdnax78jn">No shipping. No waiting.</p>
          <p className="mt-1 text-sm text-ink-muted" data-id="element-65" data-mp="3lruzfk5uv7lx">Start exploring the collection after accessing your files.</p>
        </div>
        <div className="md:border-l md:border-brand/20 md:pl-10" data-id="element-66" data-mp="2t50igx88yqd7">
          <h2 className="font-heading text-2xl font-bold uppercase" data-id="element-67" data-mp="2t37czl9dec6s">
            Print it or <span className="text-brand" data-id="element-68" data-mp="2y2s81klf60e8">use it digitally</span>
          </h2>
          <div className="mt-6 space-y-5" data-id="element-69" data-mp="32w4w9tm6s56g">
            <div className="flex gap-3" data-id="element-70" data-mp="32wwk2i9jkym6">
              <PrinterIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-71" data-mp="25gha6hp76dl4" />
              <p className="text-sm leading-relaxed text-ink-muted" data-id="element-72" data-mp="2ae0plkxmswen">
                <strong className="block text-ink" data-id="element-73" data-mp="22e344v27iid9">Prefer paper in the workshop?</strong>
                Print the project pages you need.
              </p>
            </div>
            <div className="flex gap-3" data-id="element-74" data-mp="1yc97cxv4tyid">
              <TabletIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-75" data-mp="2c3mk9syjby4f" />
              <p className="text-sm leading-relaxed text-ink-muted" data-id="element-76" data-mp="2753120bbt0fr">
                <strong className="block text-ink" data-id="element-77" data-mp="276w6xde47gmp">Prefer working from a tablet?</strong>
                Keep the plans beside your workbench.
              </p>
            </div>
          </div>
          <p className="mt-6 text-sm font-medium" data-id="element-78" data-mp="1ffgev3tsh1p3">The collection is designed to be practical in both formats.</p>
        </div>
      </div>
    </section>;
}